import { render, staticRenderFns } from "./dealer-agreement.vue?vue&type=template&id=c7acf6d0"
import script from "./dealer-agreement.vue?vue&type=script&lang=js"
export * from "./dealer-agreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports